
define('text!templates/filter_list_item.html',[],function () { return '<li class="fl-item filtered {{#selected}}selected{{/selected}}" data-id="{{id}}" {{dataAttributes}} title="{{origText}}">\n\t<label>\n\t\t<input type="checkbox" {{#selected}}checked{{/selected}}>\n\t\t<span>{{name}}</span>\n\t</label>\n</li>\n';});

